import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import { fetchMe } from "../providers/local/dataProvider";
import { principalCacheKey } from "../providers/local/principal";
import {
  clearWorkspace,
  getWorkspace,
  setWorkspace,
} from "../providers/local/workspace";

/**
 * Picks the workspace (0025, W15 M9): originations, recruiting … Shown only to
 * someone who may open more than one. Switching reloads the app, so nothing
 * from one workspace stays on screen in another.
 */
export function WorkspaceSwitcher() {
  const me = useQuery({
    queryKey: ["me-workspaces", principalCacheKey()],
    queryFn: fetchMe,
    staleTime: 5 * 60_000,
  });
  const workspaces = me.data?.workspaces ?? [];
  const current = getWorkspace();

  // A stored choice the BFF refused (no longer a member): back to the default.
  useEffect(() => {
    if (me.data && me.data.workspace === null) {
      clearWorkspace();
      window.location.reload();
    }
  }, [me.data]);

  if (workspaces.length < 2) return null;
  return (
    <label className="block px-2 pb-1 text-xs text-muted-foreground">
      <span className="sr-only">Workspace</span>
      <select
        aria-label="Workspace"
        className="mt-1 h-8 w-full rounded-md border border-input bg-background px-2 text-sm text-foreground"
        value={current}
        onChange={(event) => {
          setWorkspace(event.target.value);
          window.location.assign("#/");
          window.location.reload();
        }}
      >
        {workspaces.map((w) => (
          <option key={w.id} value={w.slug}>
            {w.name}
          </option>
        ))}
      </select>
    </label>
  );
}
